const EmailRegex =
	/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const PostalCodeRegex = /^(?:\d{5}|[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ ]?\d[ABCEGHJ-NPRSTV-Z]\d)$/i;

export const isValidEmail = (email: string) => EmailRegex.test(email);

/**
 * Validates if an input is a valid postal code.
 *
 * Valid postal codes:
 *   11111 (US 5 digit)
 *   A1A 1A1 (Canada - with space)
 *   A1A1A1 (Canada - no space)
 *
 * @param postalCode - The zip/postal code to verify
 */
export const isValidPostalCode = (postalCode: string) => PostalCodeRegex.test(postalCode);
